// ===== 全局配置（ESM 版）=====
// 供所有 ESM bundle 使用

export const API_BASE = (location.hostname === 'localhost' || location.hostname === '127.0.0.1')
  ? 'http://localhost:5000'
  : location.protocol + '//' + location.hostname;

const DEBUG = false;

export function log() {
  if (DEBUG) {
    try { console.log.apply(console, arguments); } catch (e) {}
  }
}
